<template>
  <v-layout
    row wrap align-center
    class="company-offer"
  >
    <!-- Логотип -->
    <v-flex xs12 sm4 md3 pt-3 class="company-offer__logo">
      <img
        :src="company.logoUrl || '/uploads/company_logo/545883a84da825121f310d94320d66de.jpg'"
        :alt="company.name || 'Страховая компания'"
      />
    </v-flex>

    <!-- Коэффициенты и изменения -->
    <v-flex xs12 sm12 md6>
      <v-layout align-center justify-start row wrap v-if="company.coefficients">
        <v-flex text-xs-center>
          <span class="data-title">Срок действия</span><br />
          <span class="data-param">1 год</span>
        </v-flex>

        <v-flex v-if="company.coefficients.КТ">
          <span class="data-title">КТ</span><br />
          <span class="data-param">{{ company.coefficients.КТ.value }}</span>
        </v-flex>

        <v-flex v-if="company.coefficients.КБМ">
          <span class="data-title">КБМ</span>
          <img
            class="tip-icon"
            src="/svg/q.svg"
            alt=""
            data-tippy-animateFill="false"
            data-tippy-animation="scale"
            data-tippy-content="Коэффициент бонус-малус зависит от истории аварийности вождения"
          /><br />
          <span class="data-param">{{ company.coefficients.КБМ.value }}</span>
        </v-flex>

        <v-flex v-if="company.coefficients.КВС">
          <span class="data-title">КВС</span><br />
          <span class="data-param">{{ company.coefficients.КВС.value }}</span>
        </v-flex>

        <v-flex v-if="company.coefficients.КО">
          <span class="data-title">КО</span><br />
          <span class="data-param">{{ company.coefficients.КО.value }}</span>
        </v-flex>

        <v-flex v-if="company.coefficients.КС">
          <span class="data-title">КС</span><br />
          <span class="data-param">{{ company.coefficients.КС.value }}</span>
        </v-flex>

        <v-flex v-if="company.coefficients.КМ">
          <span class="data-title">КМ</span><br />
          <span class="data-param">{{ company.coefficients.КМ.value }}</span>
        </v-flex>
      </v-layout>

      <!-- Список изменений -->
      <v-layout
        v-if="hasChanges"
        class="changes-block"
      >
        <div>
          <div class="changes-title">Изменения:</div>
          <ul class="changes-list">
            <li
              v-for="(desc, index) in company.changes.descriptions"
              :key="index"
              class="changes-item"
            >
              {{ desc }}
            </li>
          </ul>
        </div>
      </v-layout>
    </v-flex>

    <!-- Кнопка оформления -->
    <v-flex xs12 sm6 md3 align-center>
      <v-btn
        class="button next-button block"
        :disabled="isButtonDisabled"
        :loading="isButtonLoading"
        @click="$emit('action-click')"
      >
        {{ buttonText }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
/**
 * CompanyOffer — "тупой" компонент карточки предложения страховой компании.
 *
 * Emits:
 *   action-click — пользователь кликнул на кнопку оформления
 */
export default {
  name: 'CompanyOffer',

  props: {
    company: {
      type: Object,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isButtonLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['action-click'],

  computed: {
    hasChanges() {
        const changes = this.company && this.company.changes;
        const descriptions = changes && changes.descriptions;
        return descriptions && descriptions.length > 0;
    },
  },
}
</script>

<style scoped lang="scss">
.company-offer {
  padding: 36px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(0, 0, 0, 0.2);

  &__logo {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      max-width: 200px;
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

.data-param {
  font-size: 28px;
  display: block;
  font-family: 'SFProBold', 'SFPro', sans-serif;
}

.data-title {
  font-size: 16px;
  font-weight: 400;
  color: #828282;
  font-family: 'SFUIDisplay', 'SFPro', sans-serif;
}

.changes-block {
  background: #f8f9fb;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 16px 20px;
  margin-top: 16px;
  transition: background 0.2s ease;

  &:hover {
    background: #f1f3f5;
  }

  .changes-title {
    font-weight: 600;
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
  }

  .changes-list {
    list-style: none;
    margin: 0;
    padding-left: 10px;
  }

  .changes-item {
    font-size: 13px;
    color: #444;
    margin-bottom: 4px;
    line-height: 1.4;

    &:last-child { margin-bottom: 0; }
    &::marker { color: #4a90e2; }
  }
}

.button {
  line-height: 1.45 !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 100px;
  border-style: solid;

  width: 270px;
  height: 56px;
  max-width: 100%;
  font-size: 18px !important;

  @media (max-width: 960px) {
    font-size: 16px !important;
    width: 250px;
    height: 50px;
  }

  @media (max-width: 600px) {
    font-size: 18px !important;
    width: 100%;
    height: 70px;
  }
}

.next-button {
  color: #ffffff !important;
  background-color: #00ba57 !important;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/change/components/CompanyOffer.vue